import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {createSelector} from '@ngrx/store';
import {TableCardComponent} from '@aviary/components/table-card/table-card.component';
import {PaginationSelectors, TableCardDefinition} from '@store/aviary/aviary.adapter';
import {BalanceActions} from '@store/balance/balance.actions';
import {BalanceSelectors} from '@store/balance/balance.selectors';
import {PatronBalanceTransaction} from '@store/balance/balance.types';
import {ExpandedTransactionOpacNoteComponent} from './expansion-rows/expanded-transaction-opac-note.component';
import {createStringSelector} from '@aviary/store/store.helpers';
import {
  getTransactionsTableColumnsDefinition,
  TRANSACTIONS_TABLE_EXPANSION_COLUMNS,
  TRANSACTIONS_TABLE_RESPONSIVE_DEFINITION
} from '@app/my-account/balance/balance.constants';
import {AccountBalanceComponent} from '@app/my-account/balance/account-balance/account-balance.component';

@Component({
  selector: 'px-balance',
  host: {
    class: 'flex flex-col gap-y-7'
  },
  template: `
    <mat-card>
      <mat-card-content class="px-2 md:px-4 py-4">
        <px-account-balance class="px-0 md:px-3"/>
      </mat-card-content>
    </mat-card>

    <mx-table-card [definition]="tableCardDefinition"/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardContent, AccountBalanceComponent, TableCardComponent]
})
export class BalanceComponent {
  private readonly selectors = BalanceSelectors.BalanceTransactions;

  public readonly tableCardDefinition: TableCardDefinition<PatronBalanceTransaction, typeof this.selectors> = {
    leftHeaderContent: {
      value: 'Account Activity'
    },
    table: {
      defaultSelectorContainer: this.selectors,
      dataSource: 'transactions',
      rowExpansion: {
        rowBased: {
          showIf: this.selectors.showDetailsExpansionFor,
          componentClass: ExpandedTransactionOpacNoteComponent
        },
        columnBased: {
          showIf: this.selectors.showAmountsExpansionFor,
          columns: TRANSACTIONS_TABLE_EXPANSION_COLUMNS
        }
      },
      responsiveColumnsDefinition: TRANSACTIONS_TABLE_RESPONSIVE_DEFINITION,
      columns: getTransactionsTableColumnsDefinition(this.selectors),
      hiddenDataIndicatorRow: {
        showIf: PaginationSelectors.onFinalPage,
        message: createStringSelector(
          this.selectors.includeAllTransactions,
          includeAll => includeAll ? 'End of all activity.' : 'Older activity may be hidden.'
        ),
        actionButtonLabel: createSelector<object, boolean, string>(
          this.selectors.includeAllTransactions,
          includeAll => includeAll ? 'Hide Older Activity' : 'Show All'
        ),
        clickActionCreator: BalanceActions.toggleIncludeAllBalanceTransactions
      },
      noDataRowMessage: 'No recent transactions.'
    }
  };
}
